function AuthenticationContentView() {
    /** @type {jQuery} */
    var $content = $("#authContent");

    var currentView;

    var $headerBar = $('<div data-role="header" data-theme="b" class="headerPanel" data-tap-toggle="false" data-update-page-padding="false">');
    var $headerContainer = $('<div data-type="horizontal" data-role="controlgroup" class="ui-btn-left icon-only">');
    $headerBar.append($headerContainer);
    var hasPreAuthMenu = false;

    this.addPreAuthMenu = function($preAuthMenuButton) {
        hasPreAuthMenu = true;
        $headerContainer.append($preAuthMenuButton);
    };

    this.setView = function(view) {
        if (hasPreAuthMenu) {
            view.getContent().prepend($headerBar).enhanceWithin();
        }
        view.show();

        if (currentView) {
            currentView.hide();
        }
        currentView = view;
    };

    this.addView = function(view) {
        view.hide();
        var viewContent = view.getContent();
        $content.append(viewContent);
    };

    this.show = function() {
        $content.show();

        if (currentView) {
            currentView.show();
            currentView.resize($content.width(), $content.innerHeight());
        }
    };

    this.hide = function() {
        if (currentView) {
            currentView.hide();
        }
        $content.hide();
    };

    this.resize = function(width, height) {
        $content.width(width);
        $content.outerHeight(height);

        if (currentView) {
            currentView.resize(width, $content.innerHeight());
        }
    };
}

module.exports = AuthenticationContentView;


//////////////////
// WEBPACK FOOTER
// ./logon/AuthenticationContentView.js
// module id = 17
// module chunks = 3 4